module.exports = __webpack_public_path__ + "static/media/jayendrabhai.1922cf76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jayendrabhai.jpg
// module id = 1132
// module chunks = 0